<template>
    <div class="page specials">
        <LoadingSpinner v-if="loading" color="#A32929" />
        <CenterContent v-if="!loading && !specials.length" padding="0 20px">
            <h2><span class="title">Coming Soon</span></h2>
        </CenterContent>
        <CenterContent v-else padding="0 20px">
            <div class="specials-wrap">
                <div v-for="(special, index) in specials" :key="index" class="special">
                    <img :src="imgSrc(special)" :alt="imgAlt(special)" />
                    <NewSpecial v-if="type === 'new'" :base-url="newBaseUrl" :special="special" />
                    <UsedSpecial v-else :base-url="usedBaseUrl" :special="special" :type="type" />
                </div>
            </div>
            <div class="disclaimer">
                <span v-if="type === 'new' && disclaimer.length">{{ disclaimer }}</span>
                <span v-else>
                    *Dealer not responsible for typographical errors. Pictures are for illustration
                    purposes only. See dealer for more details.
                </span>
            </div>
        </CenterContent>
    </div>
</template>

<script>
import axios from '@/plugins/axios';

import LoadingSpinner from '@/components/LoadingSpinner.vue';
import CenterContent from '@/components/CenterContent.vue';
import NewSpecial from '@/components/specials/NewSpecial.vue';
import UsedSpecial from '@/components/specials/UsedSpecial.vue';

export default {
    name: 'SpecialsPage',
    components: {
        LoadingSpinner,
        CenterContent,
        NewSpecial,
        UsedSpecial,
    },
    props: {
        arkona: {
            type: String,
            required: true,
        },
        type: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            specials: [],
            disclaimer: '',
            usedBaseUrl: '',
            newBaseUrl: '',
            loading: true,
        };
    },
    async created() {
        try {
            const { data } = await axios.get(`specials/${this.type}/${this.arkona}`);
            this.specials = data;

            await this.getBaseUrls();

            this.loading = false;
        } catch (err) {
            console.error(err);
            this.loading = false;
        }
    },
    methods: {
        imgSrc(special) {
            return special.hasPhoto
                ? `https://cars.chapmanchoice.com/stock/${special.photoLocation}/${
                      special.stockNumber
                  }.jpg`
                : `https://cars.chapmanchoice.com/stock/${special.photoLocation}/default.jpg`;
        },
        imgAlt(special) {
            return this.type === 'new'
                ? special.line0
                : `${special.year} ${special.make} ${special.model} ${special.trim}`;
        },
        async getBaseUrls() {
            const { data } = await axios.get(`specials/iframe-links/${this.arkona}`);
            this.disclaimer = data.disclaimer;
            this.newBaseUrl = data.newUrl;
            this.usedBaseUrl = data.usedUrl;
        },
    },
};
</script>

<style lang="scss" scoped>
.loading {
    padding: 100px 0;
}
.coming-soon {
    padding: 40px 0;
}
.specials-wrap {
    padding-top: 20px;
}
.special {
    padding: 20px;
    display: flex;
    align-items: flex-start;
    &:nth-child(odd) {
        background-color: #f3f3f3;
    }
}
img {
    width: 100%;
    max-width: 320px;
    margin-right: 30px;
    align-self: center;
}
.disclaimer {
    padding-top: 20px;
}
@media screen and (max-width: 800px) {
    .special {
        flex-direction: column;
    }
    img {
        margin: 0;
        margin-bottom: 30px;
    }
}
</style>
